var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconAccountPrivacyPolicy = function SvgIconAccountPrivacyPolicy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 17,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M2.5 6v-.75a4.5 4.5 0 0 1 9 0V6H13a.75.75 0 0 1 .75.75v9a.75.75 0 0 1-.75.75H1a.75.75 0 0 1-.75-.75v-9A.75.75 0 0 1 1 6zm9.75 1.5H1.75V15h10.5zm-6 4.3a1.5 1.5 0 1 1 1.5 0v1.7h-1.5zM4 6h6v-.75a3 3 0 0 0-6 0z"
  })));
};
export default SvgIconAccountPrivacyPolicy;